module.exports = __webpack_public_path__ + "img/theme_bold.fe41a1c2.png";